import { render, staticRenderFns } from "./FormControlPhone.vue?vue&type=template&id=9f02760a&"
import script from "./FormControlPhone.vue?vue&type=script&lang=js&"
export * from "./FormControlPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports